











import GiganautVue from '@/components/Shared/GiganautVue';
import { WorkerAnonModule } from '@/store/modules/workerAnon';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'Error',
  components: {  }
})
export default class Error extends Vue {

  get errorMessage() {
      return WorkerAnonModule.errorMessage;
  }

  get isError() {
      return WorkerAnonModule.isError;
  }
}
